export default __webpack_public_path__ + "static/media/storm.7741b2c5.svg";